import { gql } from "@apollo/client";

const markCustomsShipmentAsShippedMutation = gql`
  mutation ($customsShipmentId: ID!) {
    markCustomsShipmentAsShipped(customsShipmentId: $customsShipmentId) {
      errors {
        customsShipmentId
      }
      updatedCustomsShipment {
        id
        canonicalId
        createdAt
        shippedOn
        archivedOn
        controlNumber
        canViewerMarkAsShipped
        canViewerMarkAsArchived
        canViewerSetControlNumber
      }
      succeeded
    }
  }
`;

export default markCustomsShipmentAsShippedMutation;
